export class LmConfirmDialogData {
  constructor(params) {
    this.messages = params.messages || []
    this.deletable = params.deletable || false
    this.replaceable = params.replaceable || false
    this.confirmAction = params.confirmAction || ''
  }

  isConfirmable() {
    return this.deletable
  }

  isReplaceable() {
    return this.replaceable
  }

  getMessages() {
    return this.messages
  }

  getConfirmAction() {
    return this.confirmAction
  }
}
